export default "__VITE_ASSET__Cf2ByUBa__"